import angular from 'angular';

import RwEditorComponent from './rw-editor-component';

export default angular
  .module('rw-editor', [])
  .component('rwEditor', new RwEditorComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-editor/rw-editor-module.js